import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'arrayDiff',
    standalone: true,
})
export class ArrayDiffPipe implements PipeTransform {
    transform(arrayA: string[], arrayB: string[]): string[] {
        if (!Array.isArray(arrayA) || !Array.isArray(arrayB)) {
            return arrayA || [];
        }

        const setB = new Set(arrayB);
        return arrayA.filter(item => !setB.has(item));
    }
}
